<template>
  <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('societes.produitAssocieLocDefaut.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <p class="column is-12 has-text-link">
            {{$t('societes.produitAssocieLocDefaut.info')}}
          </p>
          <div class="column is-6">
            <b-field :label="$t('societes.produitAssocieLocDefaut.unitaire')">
              <b-select v-model="societe.produitAssocieLocationFaceId" expanded>
                <option></option>
                <option v-for='produit in listeProduitLoc(societe.produitAssocieLocationFaceId)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitAssocieLocDefaut.ecranNumerique')">
              <b-select v-model="societe.produitAssocieLocationEcranNumId" expanded>
                <option></option>
                <option v-for='produit in
                listeProduitLocNum(societe.produitAssocieLocationEcranNumId)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitAssocieLocDefaut.regroupement')">
              <b-select v-model="societe.produitAssocieLocationReseauTempoId" expanded>
                <option></option>
                <option
                    v-for='produit in listeProduitLoc(societe.produitAssocieLocationReseauTempoId)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitAssocieLocDefaut.regroupementNumerique')">
              <b-select v-model="societe.produitAssocieLocationReseauNumId" expanded>
                <option></option>
                <option v-for='produit in
                listeProduitLocNum(societe.produitAssocieLocationReseauNumId)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitAssocieLocDefaut.regroupementLc')">
              <b-select v-model="societe.produitAssocieLocationReseauLcId" expanded>
                <option></option>
                <option v-for='produit in
                listeProduitLoc(societe.produitAssocieLocationReseauLcId)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>

export default {
  props: {
    produitsLocation: {
      type: Array,
      required: true,
    },
    societe: {
      type: Object,
      required: true,
    },
  },
  methods: {
    listeProduitLoc(id) {
      return this.produitsLocation.filter((produitLoc) => {
        return !produitLoc.numerique && (produitLoc.actif || produitLoc.id === id);
      });
    },
    listeProduitLocNum(id) {
      return this.produitsLocation.filter((produitLoc) => {
        return produitLoc.numerique && (produitLoc.actif || produitLoc.id === id);
      });
    },
  },
};

</script>
